import React from "react";

export const StaticCard = (props) => {
  return (
    <div
      className={` ${props.className}`}
      onClick={() => props.onClick && props.onClick()}
    >
      <div className="bg-color-white w-100 color-black-4 border-black-9 border-radius-main cursor-pointer">
        <div className="flex-row flex-content-space-between p-5 h-120px w-100  ">
          <span className="text-right p-10 color-black-1 font-size-main-3 ">
            {props.name}
          </span>
          <div className="h-100 flex flex-items-end">
            <span className="text-left font-size-main-1 p-20">
              {props.value}
            </span>
            <div className="h-100 w-80px flex flex-items-center p-10 border-radius-main">
              <img src={props.icon} alt="card-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
